'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import classNames from 'classnames';
import UINavList from './UINavList';

class UIFolderNav extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return /*#__PURE__*/_jsx(UINavList, Object.assign({}, rest, {
      className: classNames(className, 'private-folder-nav'),
      _rootComponent: UIFolderNav,
      children: children
    }));
  }

}

UIFolderNav.displayName = 'UIFolderNav';
UIFolderNav.propTypes = Object.assign({}, UINavList.propTypes);
UIFolderNav.defaultProps = Object.assign({}, UINavList.defaultProps);
export default UIFolderNav;